import { useState } from 'react';

import cs from 'classnames';

import Icon from '../Icon/Icon';
import Typography from '../Typography/Typography';

const Accordion = ({ title, children, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const toggleAccordion = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div className="flex flex-col rounded-md border border-solid border-neutral-100 shadow-xs">
      <div
        className={cs(
          'flex h-[52px] cursor-pointer items-center justify-between gap-2 rounded-t-md border-0 border-b border-solid border-neutral-100 bg-white p-3 font-semibold',
          !isOpen && 'rounded-b-md border-b-0'
        )}
        onClick={toggleAccordion}>
        <Typography color="primary-900">{title}</Typography>
        <Icon
          icon="arrow-square-down"
          color="neutral"
          className={`transform transition-transform ${!isOpen ? 'rotate-180' : ''}`}
        />
      </div>
      <div
        className={`flex flex-col gap-2 p-3 transition-all duration-300   ${isOpen ? 'visible' : 'hidden'}`}>
        {children}
      </div>
    </div>
  );
};

export default Accordion;
